import {Component} from '@angular/core';
import {TableComponent} from '@shared/components/table/table.component';
import {
  ChargeInformationPriceStatusDto,
  PagedResultOfChargeInformationPriceStatusDto,
  DashboardService
} from '@app/api/dmc';
import {priceStatusTableConfig} from '@shared/table-configs/dashboard/price-status.table';
import {TableConfig} from '@shared/interfaces/table/table-config';
import {LoadingService} from '@app/core/services/loading.service';
import {HeaderService} from '@app/core/services/header.service';
import {HeaderComponent} from '@shared/components/header/header.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-pricestatus',
  imports: [
    TableComponent,
    HeaderComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard-pricestatus.component.html',
  styleUrls: ['./dashboard-pricestatus.component.css'],
})
export class DashboardPriceStatusComponent {
  public priceStatusTableConfig: TableConfig<ChargeInformationPriceStatusDto> = priceStatusTableConfig;

  public tableData: ChargeInformationPriceStatusDto[] = [];

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly loadingService: LoadingService,
    private readonly headerService: HeaderService,
  ) {
    this.fetchData();
  }

  public fetchData() {
    this.loadingService.start();
    this.dashboardService.dashboardGetChargeInformationPriceStatusGet( 1, 100).subscribe((result: PagedResultOfChargeInformationPriceStatusDto) => {
      this.tableData = result.results ?? [];
      this.loadingService.stop();
    })
  }
}
